<generic-modal #preferencesModal>
	<ng-template #modalHeading let-data="data">
		<div class="heading">
			<h3>{{ data.job.jobName }}</h3>
			<p>preferences for</p>
			<h4>{{ data.job.site }}</h4>
		</div>
	</ng-template>

	<ng-template #modalBody let-data="data">
		<div class="main-container lg-view">
			<app-loader *ngIf="isPreferencesLoading"></app-loader>

			<div class="main-form">
				<form [formGroup]="settingsForm">
					<div class="checkbox-group-container" *ngIf="pageType === PageType.Customer">
						<mat-checkbox formControlName="isNotificationDisabled">
							<div>
								<span class="primary">Another person at <span>{{ data.job.serviceProvider }}</span> does the <span>{{ data.job.jobName }}</span>{{(data.job.complianceOptionName ? ' for ' : null)}}<span>{{ (data.job.complianceOptionName ? data.job.complianceOptionName : null) }}</span></span>
								<span class="secondary">If checked, notifications and calendar entries will discontinue for you at <span>{{ data.job.site }}</span> for <span>{{ data.job.jobName }}</span></span>
							</div>
						</mat-checkbox>
					</div>

					<div class="checkbox-group-container">
						<mat-checkbox formControlName="isJobAutoSkipped" [disabled]="!preferencesData.preferences.allowSkipForSite">
							<div>
								<span class="primary"><span>{{ data.job.jobName }}</span>{{ (data.job.complianceOptionName ? ' for ' : null) }}<span>{{ (data.job.complianceOptionName ? data.job.complianceOptionName : null) }}</span> is not performed at <span>{{ data.job.site }}</span></span>
								<span class="secondary">If checked, <span>{{ data.job.jobName }}</span>{{ data.job.complianceOptionName ? ' for ' : null }}<span>{{ (data.job.complianceOptionName ? data.job.complianceOptionName : null) }}</span> will no longer appear in the platform.</span>
							</div>
						</mat-checkbox>

						<span *ngIf="!preferencesData.preferences.allowSkipForSite" class="option-note">(This option is not allowed due to set constraints)</span>
					</div>

					<div class="vertical-flex-container" *ngIf="pageType === PageType.Customer">
						<p>Person responsible to manage this project</p>
						<mat-form-field *ngIf="data?.customers?.length">
							<mat-select formControlName="projectManager" class="contact-select-dropdown"
								[panelClass]="'contact-select-dropdown'"
								[class.empty]="settingsForm.get('projectManager')?.value == null"
								[placeholder]="settingsForm.get('projectManager')?.value ? null : 'None'">
								<mat-select-trigger>
									<div class="contact-container" *ngIf="settingsForm?.get('projectManager')?.value">
										<div class="contact-name">
											<span>{{ settingsForm.get('projectManager').value.lastName }}, {{
												settingsForm.get('projectManager').value.firstName }}</span>
											<span class="contact-title"
												*ngIf="settingsForm.get('projectManager').value?.title">{{
												settingsForm.get('projectManager').value.title }}</span>
										</div>
										<div class="contact-details">
											<span class="contact-email">{{
												settingsForm.get('projectManager').value.emailAddress
												}}</span>
											<span class="contact-phone">{{
												settingsForm.get('projectManager').value.phoneNumber
												}}</span>
										</div>
									</div>
								</mat-select-trigger>

								<mat-option [value]="null">
									<span class="contact-container">None</span>
								</mat-option>
								<mat-option *ngFor="let contact of data.customers" [value]="contact">
									<div class="contact-container">
										<div class="contact-name">
											<span>{{ contact.lastName }}, {{ contact.firstName }}</span>
											<span class="contact-title" *ngIf="contact.title">{{ contact.title
												}}</span>
										</div>
										<div class="contact-details">
											<span class="contact-email">{{ contact.emailAddress }}</span>
											<span class="contact-phone">{{ contact.phoneNumber }}</span>
										</div>
									</div>
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</form>
			</div>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="submitPreferences()"
			[disabled]="isPreferencesLoading">Submit</button>
		<button mat-flat-button (click)="settingsForm.reset(); preferencesModal.hide()"
			[disabled]="isPreferencesLoading">Cancel</button>
	</ng-template>
</generic-modal>
